// extracted by mini-css-extract-plugin
export default {"background":"Title_background__6KKdv","text":"Title_text__5dF29"};